import React, {useEffect, useState} from "react";
import ReactQuill from 'react-quill';
import Select from 'react-select'
import ImageEditor from '../Editor/ImageEditor';

import { stripHtml } from '../Forms/sharedUtils';
import 'react-quill/dist/quill.snow.css';
const quillModules = {
  toolbar: [
    [{ 'header': [2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline','strike', 'blockquote'],
    [{ 'align': [] }],
    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
    ['link', 'image'],
    ['clean']
  ]
}

const quillFormats = [
  'header',
  'bold', 'italic', 'underline', 'strike', 'blockquote', 'align',
  'list', 'bullet', 'indent',
  'link', 'image'
]
const FormDetails = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors, touched,
    setFieldValue
  } = props;
  const [categories, setCategories] = useState([]);
  const fetchCategories = async () => {
    const resp = await fetch('/account/listings/categories.json');
    const data = await resp.json()
    console.log('dd', data);
    setCategories(data);
  }

  useEffect(() => {
    fetchCategories()
  }, [])

  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-tag"></i> Details
          </h3>
        </div>
        <div className="row with-forms">
        <ImageEditor/>
          <div className="col-md-6">
            <h5>Listing Title
              <sup className="required">*</sup>
            </h5>
            <input
              type="text"
              name="title"
              id="title"
              placeholder="Blog Title"
              autoComplete="off"
              value={`${values.title || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              required={true}
              className={
                errors.title && touched.title
                  ? "search-field error"
                  : "search-field"
              }
            />           
          </div>

        </div>

        <div className="row with-forms">
     
          <div className="col-md-12">
            <h5>Content
            <sup className="required">*</sup>
            </h5>
            <textarea 
              required={true} className="invisibled" 
              name="content" 
              value={`${stripHtml(values.content) || ''}`}
              onChange={e => (e)}
            ></textarea>
            <ReactQuill 
              theme="snow" 
              value={`${values.content || ''}`}
              onChange={(value) => setFieldValue('content', value)}
              modules={quillModules}
              formats={quillFormats}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormDetails;
